//CardActions
export const FETCH_CARDS = 'FETCH_CARDS';
export const NEW_CARDS = 'NEW_CARDS';
export const REVEAL_OPTION = 'REVEAL_OPTION';
export const UPDATE_FILE_IDS = 'UPDATE_FILE_IDS';
export const REPLACE_FILE_IDS = 'REPLACE_FILE_IDS';
export const REPLACE_CARDS = 'REPLACE_CARDS';
export const UPDATE_MODE = 'UPDATE_MODE';
export const UPDATE_MODE_OPTIONS = 'UPDATE_MODE_OPTIONS';
export const UPDATE_FORMAT = 'UPDATE_FORMAT';
export const UPDATE_LEARN_DATA = 'UPDATE_LEARN_DATA';
export const RESET_LEARN_DEMO = 'RESET_LEARN_DEMO'

//BuildActions
export const BUILD_CARD = 'BUILD_CARD';
export const UPDATE_FILE_NAME = 'UPDATE_FILE_NAME';
export const UPDATE_FORM_ELEMENT_DATA = 'UPDATE_FORM_ELEMENT_DATA';
export const UPDATE_FORMAT_FORM_ELEMENT_DATA = 'UPDATE_FORMAT_FORM_ELEMENT_DATA';
export const UPDATE_FORMAT_FORM_ELEMENTS = 'UPDATE_FORMAT_FORM_ELEMENTS';
export const UPDATE_BUILD_FILE_ID = 'UPDATE_BUILD_FILE_ID';
export const UPDATE_BUILD_CARD_FORMAT = 'UPDATE_BUILD_CARD_FORMAT';
export const RESET_BUILD_DATA = 'RESET_BUILD_DATA';



// WEBPACK FOOTER //
// ./src/actions/types.js